export default "__VITE_ASSET__ef18c19b__"